<template>
  <!--多选题-->
  <div class="questionModule">
    <!--  {{stu}}-->
    <!--  {{formData}}-->
    <el-form ref="questionData" :model="questionData" label-width="100px" size="small" :rules="questionDataRules">
      <el-form-item label="题目内容" prop="questionName" class="form-item">
        <Editor
            :id="1"
            :html="questionData.questionName"
            @changeHtml="editor1"
        ></Editor>
      </el-form-item>
      <el-form-item label=" " prop="userShow" class="form-item" v-if="stu != 2&&stu != 3">
        <el-checkbox v-model="questionData.userShow">学员练习可见</el-checkbox>
      </el-form-item>
      <el-form-item label="选项内容" prop="tableData" class="form-item">
        <el-table
            ref="multipleTable"
            :data="tableData"
            :header-cell-style="tableHeader"
            size="small"
            tooltip-effect="dark"
            stripe

            style="width: 100%;max-width: 1200px"

            @selection-change="selectItem"
            :header-cell-class-name="leftHeaderStyle">

          <!--@select-all="onSelectAll"-->
          <!--@row-click="onSelectOp"-->
          <el-table-column
              type="selection"
              width="100"
              align="center" />
          <el-table-column
              property="content"
              label="选项内容"
              min-width="260"
              align="center">
            <template slot-scope="{ row }">
              <span style="font-size: 14px;display: inline-block;width: 20px;">{{ optionFM(row.index) }}.</span>

              <el-input v-model="row.content" placeholder="请输入选项内容" style="display: inline-block;width: calc(100% - 20px);"></el-input>

            </template>
          </el-table-column>
          <el-table-column
              property="address"
              label="上传图片"
              min-width="100"
              align="center">

            <template slot-scope="{ row }">
              <el-upload
                  :on-change="
                        (res, file) => {
                          return handleAvatarSuccess2(res, file, row);
                        }
                      "
                  :before-upload="$beforeAvatarUpload"
                  :http-request="$requestMine"
                  :show-file-list="false"
                  class="img-el-upload"
                  action
                  accept="image/png, image/gif, image/jpg, image/jpeg"
              >

                <el-image
                    :src="
                          row.img ||
                          require('@/assets/develop.png')
                        "
                    fit="contain"
                    class="imgCenter"
                ></el-image>
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column
              property="address"
              label="操作"
              align="center"
              width="120">
            <template slot-scope="{ row }">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="delRow(row)" :disabled="tableData.length<4">删除选项</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="success" icon="el-icon-plus" size="mini" @click="addRow" style="margin-top: 10px;" :disabled="tableData.length>9">添加选项</el-button>

      </el-form-item>
      <el-form-item label="题目解析" prop="answerAnalysis" class="form-item">
        <Editor
            :id="2"
            :html="questionData.answerAnalysis"
            @changeHtml="editor2"
        ></Editor>
      </el-form-item>
      <el-form-item class="btnBox">
        <el-button class="bgc-bv" @click="doClose">取消</el-button>
        <el-button class="bgc-bv" @click="getSure('questionData')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>


import Editor from "@/components/editor.vue";
import List from "@/mixins/List";

export default {
  name: "MultipleChoiceQuestions",
  components: {
    Editor
  },
  props: {
    stu: String,
    bankId: String,
    formData: Object,

    'questionInfo': {
      type: Object,
      default(){// 函数式默认值
        return null
      }
    }
  },
  mixins: [List],
  data() {
    return {
      questionData:{
        questionName: '',// 题目内容
        userShow: true,
        answerAnalysis: '',// 题目解析
      },

      tableData: [{
        index: 0,
        content: '',
        imgKey: '',
        img: ''
      }, {
        index:1,
        content: '',
        imgKey: '',
        img: ''
      }, {
        index:2,
        content: '',
        imgKey: '',
        img: ''
      }, {
        index:3,
        content: '',
        imgKey: '',
        img: ''
      }],
      multipleSelection: [],

      questionDataRules: {
        questionName: [
          { required: true, message: "请输入题目内容", trigger: "blur" },
        ],
        answerAnalysis: [
          { required: true, message: "请输入题目解析", trigger: "blur" },
        ],
      }

    };
  },
  computed: {},
  created() {
    let _this = this
    // stu = 1 获取题目数据
    if(this.formData.questionId&&this.stu == '1'){
      this.getQuestionInfo(this.$route.query.questionId)
    }
    // stu = 2 获取题目数据

    if(this.stu == '2' && this.questionInfo != null){

      this.isEdit = true
      this.currentIndex = this.questionInfo.index

      this.questionData = {
        questionName: this.questionInfo.questionName,
        userShow: this.questionInfo.userShow,
        answerAnalysis: this.questionInfo.answerAnalysis
      }

      this.tableData = this.questionInfo.questionOptionList

      this.$nextTick(()=>{
        // 正确答案选中
        this.questionInfo.answerList.forEach((eInner,iInner)=>{
          // console.log()
          this.$refs.multipleTable.toggleRowSelection(this.questionInfo.questionOptionList.find( item => item.index == _this.optionFN(eInner)));
        })
      })


    }

    // stu = 3 获取题目数据
    if(this.formData.paperQuestionId&&this.stu == '3'){
      this.getPaperQuestionInfo(this.$route.query.paperQuestionId)
    }
  },
  methods: {
    // 获取题目详情
    getQuestionInfo(questionId){
      let _this = this
      this.$post("/biz/exam/bank/question/getInfo", { questionId },3000,true,6)
          .then((ret) => {
            if (ret.status == 0) {
              //给父组件赋值
              this.$parent.formData.questionType = ret.data.questionType
              this.$parent.formData.knowledgeId = ret.data.knowledgeId
              this.$parent.formData.difficultyLevel = ret.data.difficultyLevel

              this.questionData = {
                questionName: ret.data.questionName,
                userShow: ret.data.userShow,
                answerAnalysis: ret.data.answerAnalysis,
              }
              // 选项赋值
              let optionList = []
              let optionJsonList = JSON.parse(ret.data.optionJson) || []
              optionJsonList.forEach((e,i)=>{
                let item = {
                  content: e.content,
                  img: e.img,
                  imgKey: '',
                  index: _this.optionFN(e.key)
                }
                optionList.push(item)
              })
              _this.tableData = optionList

              this.$nextTick(()=>{
                // 正确答案选中
                ret.data.standardAnswer.split(',').forEach((eInner,iInner)=>{
                  // console.log(optionList.find( item => item.index ==_this.optionFN(eInner)))
                  this.$refs.multipleTable.toggleRowSelection(optionList.find( item => item.index ==_this.optionFN(eInner)));
                })
              })

            }
          })
          .catch((err) => {
            return;
          });
    },
    // 获取试卷题目详情
    getPaperQuestionInfo(paperQuestionId){
      let _this = this
      this.$post("/biz/exam/bank/paper/question/getInfo", { paperQuestionId },3000,true,6)
          .then((ret) => {
            if (ret.status == 0) {
              //给父组件赋值
              this.$parent.formData.questionType = ret.data.questionType
              // this.$parent.formData.knowledgeId = ret.data.knowledgeId
              // this.$parent.formData.difficultyLevel = ret.data.difficultyLevel

              this.questionData = {
                questionName: ret.data.questionName,
                // userShow: ret.data.userShow,
                answerAnalysis: ret.data.answerAnalysis,
              }
              // 选项赋值
              let optionList = []
              let optionJsonList = JSON.parse(ret.data.optionJson) || []
              optionJsonList.forEach((e,i)=>{
                let item = {
                  content: e.content,
                  img: e.img,
                  imgKey: '',
                  index: _this.optionFN(e.key)
                }
                optionList.push(item)
              })
              _this.tableData = optionList

              this.$nextTick(()=>{
                // 正确答案选中
                ret.data.standardAnswer.split(',').forEach((eInner,iInner)=>{
                  // console.log(optionList.find( item => item.index ==_this.optionFN(eInner)))
                  this.$refs.multipleTable.toggleRowSelection(optionList.find( item => item.index ==_this.optionFN(eInner)));
                })
              })

            }
          })
          .catch((err) => {
            return;
          });
    },

    leftHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "seltAllbtnDis";
      }
    },
    selectItem(rows) {
      this.multipleSelection = rows;
    },
    // 删除选项行
    delRow(row){
      this.tableData.splice(row.index,1)
      this.tableData.forEach((e,i)=>{
        e.index = i
      })
    },
    // 添加选项行
    addRow(row){
      this.tableData.push({
        index: this.tableData.length,
        content: '',
        imgKey: '',
        img: ''
      })
    },
    //图片上传
    handleAvatarSuccess2(res, fiie, row) {

      let extension = res.name.substring(
          res.name.lastIndexOf(".") + 1,
          res.name.length
      );
      let formData = new FormData();
      formData.append("file ", res.raw);
      formData.append("fileType ", extension);
      formData.append("folder ", "CT_QUESTION_BANK");
      formData.append("isPublic ", true);
      const that = this;
      that
          .$Postformat("/sys/file/upload", formData, 3000, true, 6)
          .then((result) => {
            that.tableData.forEach((e,i)=>{
              if(e.index == row.index){
                row.imgKey = result.data.fileKey || "";
                row.img = result.data.fileUrl || "";
              }
            })
          })
          .catch(() => {
            setTimeout(() => {
              that.$message({
                type: "warning",
                message: "上传失败",
              });
            }, 300);
          });
    },
    // 题目内容
    editor1(e) {
      this.questionData.questionName = e;
    },
    // 题目解析
    editor2(e) {
      this.questionData.answerAnalysis = e;
    },
    // 点击取消
    doClose() {
      // stu 1题库  2组合题(单一题型)/组合题(复合题型)  3试卷
      if(this.formData.stu == '1'||this.formData.stu == '3'){
        // 返回题目列表
        this.$parent.$router.back()
      }else if(this.formData.stu == '2'){
        // 关闭弹层
        this.$parent.handleClose()
      }
    },
    // 提交表单数据
    getSure(formData) {
      let _this = this
      // stu 1题库  2组合题(单一题型)/组合题(复合题型)  3试卷
      if(this.formData.stu == '1') {
        let hasFalse = false;
        this.$parent.$refs.formData.validate((valid) => {
          if(!this.formData.knowledgeId){
            this.$message.error('请选择知识点！')
            hasFalse = true
          }
          if (valid) {
            this.$refs[formData].validate((valid) => {
              // console.log(valid);
              // console.log(this.questionData);
              if (valid) {
                let hasFalse = false;
                try{
                  this.tableData.forEach((e,i)=>{
                    if(!e.content&&!e.img){
                      this.$message.error('每个选项至少填写内容和图片的一项，请补全第'+(i+1)+'个选项！')
                      hasFalse = true
                      throw new Error() //终止循环
                    }
                  })
                } catch {}
                if(this.multipleSelection.length == 0){
                  this.$message.error('请至少选择一项正确答案！')
                  hasFalse = true
                }
                if(this.questionData.questionName.length>2000){
                  this.$message.error('题目内容超过最大文本限制！')
                  hasFalse = true
                }
                if(this.questionData.answerAnalysis.length>1000){
                  this.$message.error('题目解析超过最大文本限制！')
                  hasFalse = true
                }
                if(!hasFalse){
                  // console.log('stu',this.stu)
                  // console.log('formData',this.formData)
                  // console.log('questionData',this.questionData)
                  // console.log('tableData',this.tableData)
                  // console.log('multipleSelection',this.multipleSelection)

                  // 选项列表初始化
                  let questionOptionList = []
                  this.tableData.forEach((e,i)=>{
                    let item = {
                      content: e.content,
                      img: e.img,
                      key: _this.optionFM(e.index)
                    }
                    questionOptionList.push(item)
                  })
                  let answerList = []
                  this.sortByKey(this.multipleSelection,'index').forEach((e,i)=>{
                    answerList.push(_this.optionFM(e.index))
                  })
                  // 提交参数集合
                  let params = {
                    bankId: this.formData.bankId, // 题库ID
                    questionType: this.formData.questionType, // 题目类型
                    difficultyLevel: this.formData.difficultyLevel, // 难度
                    knowledgeId: this.formData.knowledgeId, // 知识点

                    questionName: this.questionData.questionName, // 题目内容
                    userShow: this.questionData.userShow, // 学院练习可见
                    answerAnalysis: this.questionData.answerAnalysis, // 题目解析

                    questionOptionList: questionOptionList, // 选项集合
                    answerList: answerList, //正确答案集合
                  }

                  let url = "/biz/exam/bank/question/insert";// 新增接口地址
                  if(this.formData.questionId){
                    params.questionId = this.formData.questionId // 题目ID
                    url = "/biz/exam/bank/question/modify";// 修改接口地址
                  }

                  // console.log('提交写这里',params)

                  this.$post(url, params,3000,true,6)
                      .then((ret) => {

                        if (ret.status == 0) {
                          this.$message({
                            message: ret.message,
                            type: "success",
                          });
                          this.$parent.$router.push({
                            path: '/inkQuestionBank/QuestionBankManage/QuestionList',
                            query: {
                              refresh: true,
                              bankId: this.formData.bankId,
                              bankName: this.formData.bankName,
                              // questionNameStr: this.formData.questionNameStr,
                              // questionTypeStr: this.formData.questionTypeStr,
                            }
                          })
                        }
                      })
                      .catch((err) => {
                        return;
                      });
                }

              }
            });
          }

        })
      }else if(this.formData.stu == '2'){
        this.$refs[formData].validate((valid2) => {
          // console.log(this.questionData);
          if (valid2) {
            let hasFalse = false;
            try{
              if(this.multipleSelection.length == 0){
                this.$message.error('请至少选择一项正确答案！')
                hasFalse = true
                throw new Error() //终止循环
              }
              this.tableData.forEach((e,i)=>{
                if(!e.content&&!e.img){
                  this.$message.error('每个选项至少填写内容和图片的一项，请补全第'+(i+1)+'个选项！')
                  hasFalse = true
                  throw new Error() //终止循环
                }
              })
            } catch {}
            if(this.questionData.questionName.length>2000){
              this.$message.error('题目内容超过最大文本限制！')
              hasFalse = true
            }
            if(this.questionData.answerAnalysis.length>1000){
              this.$message.error('题目解析超过最大文本限制！')
              hasFalse = true
            }

            if(!hasFalse){

              // 选项列表初始化
              let answerList = []
              this.sortByKey(this.multipleSelection,'index').forEach((e,i)=>{
                answerList.push(_this.optionFM(e.index))
              })
              // 提交参数集合
              let params = {
                // bankId: this.formData.bankId, // 题库ID
                questionType: this.formData.questionType, // 题目类型
                // difficultyLevel: this.formData.difficultyLevel, // 难度
                // knowledgeId: this.formData.knowledgeId, // 知识点

                questionName: this.questionData.questionName, // 题目内容
                // userShow: this.questionData.userShow, // 学院练习可见
                answerAnalysis: this.questionData.answerAnalysis, // 题目解析

                questionOptionList: this.tableData, // 选项集合
                answerList: answerList, //正确答案集合
              }
              if(this.isEdit){
                params.isEdit = this.isEdit
                params.currentIndex = this.currentIndex
              }
              this.$emit('successBack',params);
              this.$parent.handleClose()

            }
          }
        });
      }else if(this.formData.stu == '3') {

        this.$refs[formData].validate((valid) => {
              // console.log(valid);
              // console.log(this.questionData);
              if (valid) {
                let hasFalse = false;
                try{
                  this.tableData.forEach((e,i)=>{
                    if(!e.content&&!e.img){
                      this.$message.error('每个选项至少填写内容和图片的一项，请补全第'+(i+1)+'个选项！')
                      hasFalse = true
                      throw new Error() //终止循环
                    }
                  })
                } catch {}
                if(this.multipleSelection.length == 0){
                  this.$message.error('请至少选择一项正确答案！')
                  hasFalse = true
                }
                if(this.questionData.questionName.length>2000){
                  this.$message.error('题目内容超过最大文本限制！')
                  hasFalse = true
                }
                if(this.questionData.answerAnalysis.length>1000){
                  this.$message.error('题目解析超过最大文本限制！')
                  hasFalse = true
                }
                if(!hasFalse){
                  // console.log('stu',this.stu)
                  // console.log('formData',this.formData)
                  // console.log('questionData',this.questionData)
                  // console.log('tableData',this.tableData)
                  // console.log('multipleSelection',this.multipleSelection)

                  // 选项列表初始化
                  let questionOptionList = []
                  this.tableData.forEach((e,i)=>{
                    let item = {
                      content: e.content,
                      img: e.img,
                      key: _this.optionFM(e.index)
                    }
                    questionOptionList.push(item)
                  })
                  let answerList = []
                  this.sortByKey(this.multipleSelection,'index').forEach((e,i)=>{
                    answerList.push(_this.optionFM(e.index))
                  })
                  // 提交参数集合
                  let params = {
                    paperId: this.formData.paperId,
                    partitionId: this.formData.partitionId,


                    questionType: this.formData.questionType, // 题目类型
                    // difficultyLevel: this.formData.difficultyLevel, // 难度
                    // knowledgeId: this.formData.knowledgeId, // 知识点

                    questionName: this.questionData.questionName, // 题目内容
                    // userShow: this.questionData.userShow, // 学院练习可见
                    answerAnalysis: this.questionData.answerAnalysis, // 题目解析

                    questionOptionList: questionOptionList, // 选项集合
                    answerList: answerList, //正确答案集合
                  }

                  let url = "/biz/exam/bank/paper/question/insert";// 新增接口地址
                  if(this.formData.paperQuestionId){
                    params.paperQuestionId = this.formData.paperQuestionId // 题目ID
                    url = "/biz/exam/bank/paper/question/modify";// 修改接口地址
                  }

                  // console.log('提交写这里',params)

                  this.$post(url, params,3000,true,6)
                      .then((ret) => {

                        if (ret.status == 0) {
                          this.$message({
                            message: ret.message,
                            type: "success",
                          });
                          // 编辑 - 试卷
                          this.$parent.$router.back()
                        }
                      })
                      .catch((err) => {
                        return;
                      });
                }

              }
            });

      }
    },
    // 选项顺序替换成字母
    optionFM(msg) {
      return String.fromCharCode('A'.charCodeAt(0) + msg);
    },
    // 选项字母替换成顺序
    optionFN(msg) {
      return msg.charCodeAt(0) - 'A'.charCodeAt(0);
    },
    //数组对象方法排序:升序
    sortByKey(array,key){
      return array.sort(function(a,b){
        var x=a[key];
        var y=b[key];
        return ((x<y)?-1:((x>y)?1:0));
      });
    },
    //数组对象方法排序:降序
    sortDownByKey(array,key){
      return array.sort(function(a,b){
        var x=a[key];
        var y=b[key];
        return ((x>y)?-1:((x<y)?1:0));
      });
    },
  }
}
</script>

<style lang="less" scoped>
.btnBox{
  display: flex;justify-content: center;margin-top: 20px;
}
/deep/.el-form-item--small .el-form-item__error{
  padding-top: 6px;
}

/deep/ .seltAllbtnDis .cell .el-checkbox__inner {
  display: none;
  position: relative;
}
/deep/ .seltAllbtnDis .cell::before{
  content: '勾选正确答案';
  position: absolute;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
}
/deep/.el-table th.el-table__cell{
  background: #ecf5ff!important;
  color: #333!important;
  border-color: #ecf5ff!important;
}
.img-el-upload{
  margin: 0 auto;
  width: 88px;
  height: 88px;

}
/deep/.el-upload{
  width: 100%;
  height: 100%;
}
/deep/.el-form-item{
  margin-bottom: 22px;
}
//.editor{
//  width: 700px!important;
//}
</style>